import { useDisclosure } from '@telescope/cassini-hooks';
import { Alert, AlertDescription, AlertIcon, CloseButton, Flex } from '@telescope/cassini-ui';

interface PreviewAlertProps {
  isPreview: boolean;
}
export const PreviewAlert = ({ isPreview }: PreviewAlertProps) => {
  const { isOpen: isVisible, onClose } = useDisclosure({ defaultIsOpen: true });

  if (!isPreview || !isVisible) return null;

  return (
    <Alert status="warning" variant="solid">
      <Flex justify="center" flex={1}>
        <AlertIcon />
        <AlertDescription>This page is for preview purposes only. Some features may be disabled.</AlertDescription>
      </Flex>
      <CloseButton onClick={onClose} />
    </Alert>
  );
};
